var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestaurantMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7742 11.4972C24.3892 13.8822 21.1642 14.6322 18.8692 13.5672L16.6642 15.7722L25.9342 25.0422C26.5192 25.6272 26.5192 26.5722 25.9342 27.1572C25.3492 27.7422 24.4042 27.7422 23.8192 27.1572L14.5492 17.8872L5.2642 27.1422C4.6792 27.7272 3.7342 27.7272 3.1492 27.1422C2.5642 26.5572 2.5642 25.6122 3.1492 25.0272L16.7392 11.4372C15.6742 9.14215 16.4242 5.91715 18.8092 3.53215C21.6892 0.667153 25.7992 0.127153 27.9892 2.31715C30.1942 4.52215 29.6392 8.63215 26.7742 11.4972ZM12.9442 12.0372L8.6992 16.2822L2.4142 10.0122C0.569198 8.15215 0.179198 5.40715 1.2442 3.17215C1.6942 2.24215 2.9392 2.04715 3.6592 2.76715L12.9442 12.0372Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurantMenu);
export default __webpack_public_path__ + "static/media/restaurant-menu.608fd7a2.svg";
export { ForwardRef as ReactComponent };